export default "__VITE_ASSET__c9530728__"